import * as tslib_1 from "tslib";
import { Input, StringInput } from './input';
var Iteratee = (function () {
    function Iteratee() {
    }
    Iteratee.prototype.isCont = function () {
        return true;
    };
    Iteratee.prototype.isDone = function () {
        return false;
    };
    Iteratee.prototype.isError = function () {
        return false;
    };
    Iteratee.prototype.run = function (input) {
        var next = this;
        while (next.isCont() && (!input.isEmpty() || input.isDone())) {
            next = next.feed(input);
        }
        if (next.isCont() && input.isEmpty() && !input.isDone()) {
            next = next.feed(Input.done());
        }
        return next;
    };
    Iteratee.prototype.parse = function (input) {
        if (typeof input === 'string') {
            input = new StringInput(input);
        }
        var parser = this.run(input);
        if (!input.isEmpty() && parser.isDone()) {
            parser = Iteratee.unexpected(input);
        }
        return parser.bind();
    };
    Iteratee.prototype.bind = function () {
        throw this;
    };
    Iteratee.prototype.trap = function () {
        throw this;
    };
    Iteratee.prototype.asVariant = function () {
        return this;
    };
    Iteratee.prototype.asError = function () {
        throw this;
    };
    Iteratee.done = function (value) {
        return new IterateeDone(value);
    };
    Iteratee.error = function (cause) {
        return new IterateeError(cause);
    };
    Iteratee.unexpected = function (input) {
        var message = 'unexpected ';
        if (!input.isEmpty()) {
            message += JSON.stringify(String.fromCharCode(input.head()));
        }
        else {
            message += 'end of input';
        }
        return Iteratee.error(message);
    };
    Iteratee.expected = function (expected, input) {
        if (typeof expected === 'number') {
            expected = String.fromCharCode(expected);
        }
        if (expected.length === 1) {
            expected = JSON.stringify(expected);
        }
        var message = 'expected ' + expected;
        if (!input.isEmpty()) {
            message += ', but found ' + JSON.stringify(String.fromCharCode(input.head()));
        }
        return Iteratee.error(message);
    };
    Iteratee.isSpace = function (c) {
        return c === 0x20 || c === 0x9;
    };
    Iteratee.isNewline = function (c) {
        return c === 0xA || c === 0xD;
    };
    Iteratee.isWhitespace = function (c) {
        return Iteratee.isSpace(c) || Iteratee.isNewline(c);
    };
    Iteratee.isAlpha = function (c) {
        return c >= 65 && c <= 90
            || c >= 97 && c <= 122;
    };
    Iteratee.toLowerCase = function (c) {
        if (c >= 65 && c <= 90) {
            return c + (97 - 65);
        }
        else {
            return c;
        }
    };
    Iteratee.isDigit = function (c) {
        return c >= 48 && c <= 57;
    };
    Iteratee.decodeDigit = function (c) {
        if (c >= 48 && c <= 57) {
            return c - 48;
        }
        else {
            throw c;
        }
    };
    Iteratee.isHexChar = function (c) {
        return c >= 65 && c <= 70
            || c >= 97 && c <= 102
            || c >= 48 && c <= 57;
    };
    Iteratee.decodeHexChar = function (c) {
        if (c >= 48 && c <= 57) {
            return c - 48;
        }
        else if (c >= 65 && c <= 70) {
            return 10 + (c - 65);
        }
        else if (c >= 97 && c <= 102) {
            return 10 + (c - 97);
        }
        else {
            throw c;
        }
    };
    Iteratee.isBase64Char = function (c) {
        return c >= 48 && c <= 57
            || c >= 65 && c <= 90
            || c >= 97 && c <= 122
            || c === 43 || c === 45
            || c === 47 || c === 95;
    };
    Iteratee.decodeBase64Digit = function (c) {
        if (c >= 65 && c <= 90) {
            return c - 65;
        }
        else if (c >= 97 && c <= 122) {
            return c - 71;
        }
        else if (c >= 48 && c <= 57) {
            return c + 4;
        }
        else if (c === 43 || c === 45) {
            return 62;
        }
        else if (c === 47 || c === 95) {
            return 63;
        }
        else {
            throw c;
        }
    };
    return Iteratee;
}());
export { Iteratee };
var IterateeDone = (function (_super) {
    tslib_1.__extends(IterateeDone, _super);
    function IterateeDone(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    IterateeDone.prototype.isCont = function () {
        return false;
    };
    IterateeDone.prototype.isDone = function () {
        return true;
    };
    IterateeDone.prototype.feed = function (input) {
        return this;
    };
    IterateeDone.prototype.bind = function () {
        return this.value;
    };
    return IterateeDone;
}(Iteratee));
var IterateeError = (function (_super) {
    tslib_1.__extends(IterateeError, _super);
    function IterateeError(cause) {
        var _this = _super.call(this) || this;
        _this.cause = cause;
        return _this;
    }
    IterateeError.prototype.isCont = function () {
        return false;
    };
    IterateeError.prototype.isError = function () {
        return true;
    };
    IterateeError.prototype.feed = function (input) {
        return this;
    };
    IterateeError.prototype.bind = function () {
        throw this.cause;
    };
    IterateeError.prototype.trap = function () {
        return this.cause;
    };
    IterateeError.prototype.asError = function () {
        return this;
    };
    return IterateeError;
}(Iteratee));
//# sourceMappingURL=data:application/json;base64,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